import { CSSProperties } from 'react';
import styled from '@emotion/styled';

import { getCSSProperties } from '../../utils';

export type TextProps = CSSProperties;

export const Text = styled.p<TextProps>((props) => ({
  ...getCSSProperties(props),
}));
